import { useEffect, useState } from 'react'

import { getCurrentBonusProgram, BonusProgram } from 'api/dealership'
import dayjs from 'dayjs'

const getCurrentMonth = () => {
    const today = dayjs()
    const currentMonth = today.format('MMMM')
    const datesDifference = today.endOf('month').date() - today.date() + 1
    const remainingDaysInMonth = Math.max(1, datesDifference)

    return { currentMonth, remainingDaysInMonth }
}

export default function useAutoBonusTarget() {
    const [remainingDealsToGoal, setRemainingDealsToGoal] = useState(0)
    const [isBonusAchieved, setIsBonusAchieved] = useState(false)
    const [progressPercentage, setProgressPercentage] = useState(0)
    const [bonusProgram, setBonusProgram] = useState<BonusProgram | null>(null)
    const { currentMonth, remainingDaysInMonth } = getCurrentMonth()

    useEffect(() => {
        const fetchBonusProgram = async () => {
            const currentBonusProgram = await getCurrentBonusProgram()

            if (
                !currentBonusProgram.monthlyGoal ||
                !currentBonusProgram.hasActiveProgram
            ) {
                setBonusProgram(null)

                return
            }

            setBonusProgram(currentBonusProgram)

            setProgressPercentage(
                Math.min(
                    100,
                    (currentBonusProgram.monthlyDealCount /
                        currentBonusProgram.monthlyGoal) *
                        100,
                ),
            )

            const remainingDeals =
                currentBonusProgram.monthlyGoal -
                currentBonusProgram.monthlyDealCount

            setIsBonusAchieved(remainingDeals <= 0)
            setRemainingDealsToGoal(remainingDeals)
        }

        fetchBonusProgram()
    }, [])

    return {
        currentMonth,
        remainingDaysInMonth,
        progressPercentage,
        remainingDealsToGoal,
        isBonusAchieved,
        bonusProgram,
    }
}
